// extracted by mini-css-extract-plugin
module.exports = {"charError":"add-personas_charError__1tTVl","narrator":"add-personas_narrator__Henl-","deleteBlock":"add-personas_deleteBlock__3E9A_","deleteLink":"add-personas_deleteLink__6lj4B"};